interface Props {
    text?: string
}

export default function Loading(props: Props) {
    return  <div className="flex items-center py-4">
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
        <span className="ml-2 text-sm text-gray-600">{props.text ?? 'Loading...'}</span>
    </div>
}
